export default {"src":"/_next/static/media/second-place-icon.8b611518.svg","height":800,"width":800,"blurWidth":0,"blurHeight":0};